import { combineReducers } from "redux";

import * as originalsReducer from "../formulari/originals";
import * as editadesReducer from "../formulari/editades";
import * as indretsReducer from "../formulari/indrets";
import * as errorsReducer from "../formulari/mostrarErrors";
import * as formulariEnCursReducer from "../formulari/peticioEnviarFormulariEnCurs";

const rootReducer = combineReducers({
  originals: originalsReducer.default,
  editades: editadesReducer.default,
  mostrarErrors: errorsReducer.default,
  indrets: indretsReducer.default,
  peticioEnviarFormulariEnCurs: formulariEnCursReducer.default
});

export default rootReducer;
